var React = require('react');

function Cloud4 (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#fff;}")),React.createElement("g",{"id":"Layer_2","data-name":"Layer 2","key":1},React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1"},React.createElement("path",{"className":"cls-1","d":"M76.21,89.86c-35.19,2-35,2-60.4-10.19C-3.25,70.52-5.5,52,11.39,39.31l9.25-2.09A163.13,163.13,0,0,0,80.26,10.29h0c21.3-16.23,52.14-11.7,73.5,2.78a102.71,102.71,0,0,0,13.68,7.63c14.81,7,43.39,39.73,36.77,50.16-6.07,10.48-18.63,16.71-38,18-21.26,1.42-27.12,2-32.53,1a104,104,0,0,0-22.29-1.42Z"})))]);
}

Cloud4.defaultProps = {"viewBox":"0 0 205.19 90.85"};

module.exports = Cloud4;

Cloud4.default = Cloud4;
